import type { OrganizationMetricsPayload } from '@Application/AccountMetrics/Actions/accountMetricsFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class OrganizationMetricsView {
	readonly id: number;
	readonly name: string;
	readonly facilityCount: number;
	readonly userCount: number;

	constructor(payload: OrganizationMetricsPayload) {
		this.id = payload.id;
		this.name = payload.name;
		this.facilityCount = payload.facilityCount;
		this.userCount = payload.userCount;

		Object.freeze(this);
	}
}

export default OrganizationMetricsView;
